import { Component, OnInit, Input } from '@angular/core';
import { HttpModule } from '@angular/http';

// Service
import { CommonService } from '../../../common/service/common.service';
import { AccountClientDetailsService } from '../../../account-client/service/account-client-edit/account-client-details.service';
import { FlashMessagesService } from 'angular2-flash-messages/module/flash-messages.service';
import * as moment from 'moment';
import { LimiteAdicionalProposalService } from '../../service/limite-adicional-proposal/limite-adicional-proposal.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { ConfirmComponent } from '../../../shared/confirm/confirm.component';
import { Router } from '@angular/router';
import { SendLaToCtcComponent } from '../actions/send-la-to-ctc/send-la-to-ctc.component';
import { FixedLimitLAComponent } from '../fixed-limit-la/fixed-limit-la.component';

@Component({
	selector: 'app-limite-adicional-proposal',
	templateUrl: './limite-adicional-proposal.component.html',
	styleUrls: ['./limite-adicional-proposal.component.scss'],
	providers: [
		LimiteAdicionalProposalService,
		AccountClientDetailsService,
		CommonService,
		HttpModule
	],
	moduleId: module.id
})
export class LimiteAdicionalProposalComponent implements OnInit {

	@Input('propostaLCAdicionalID') propostaLCAdicionalID: string = "";
	@Input('accountClientID') accountClientID: string = "";
	@Input('profileUser') profileUser: string = "";
	@Input('segmentoID') segmentoID: string = "";

	// Permissões carregadas
	public permissoes = [];
	public guid;
	public token;

	// Não sei, mas é necessário
	public requiredFields: any[] = [];
	
	// Proposta carregada
	public proposalObj: any = [];

	// CTCs carregadas
	public ctcList;

	// Tipos de Cliente
	public clientTypes: any[] = [];

	// Layout da Proposta
	public proposalLayout: number = 0;

	// Dados fianceiros carregados
	public financialObj: any[] = [];
	public currentFinancialY: any = {};
	public currentFinancialG: any = {};
	public lcAtual: number = 0;
	public exposicaoAtual: number = 0;
	public vigenciaAtual: any = null;

	// Tabs
	private proposalLcTab: boolean = true;
	private summaryTab: boolean = false;
	private attachTab: boolean = true;
	private logTab: boolean = false;

	// Variáveis compostas
	public sumAtualAdicional: number = 0;
	public currentDate = moment(new Date(new Date().setHours(0,0,0,0))).format("YYYY-MM-DD HH:mm:ss");
    public isUserOwner = false;

	constructor(private accountClientDetailsService: AccountClientDetailsService,
				private limiteAdicionalProposalService: LimiteAdicionalProposalService,		
				private flashMessagesService: FlashMessagesService,
				private dialogService: DialogService,
				private router: Router)
	{
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.guid = localStorage.getItem('yara.userID');
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		console.log('IT\'s HERE!');

		console.log('propostaLCAdicionalID', this.propostaLCAdicionalID);
		console.log('accountClientID', this.accountClientID);
		console.log('profileUser', this.profileUser);

		this.getProposalLA(this.propostaLCAdicionalID);		
		this.getCTCByAccountClient();
		this.getClientTypes();
	}

	getProposalLA(proposalID) {
		this.limiteAdicionalProposalService.getLaProposal(proposalID).subscribe(result => {
			if (result.Success) {
				if (result.Result) {
					
					this.proposalObj = result.Result ? result.Result : [];
					console.log('proposalLAObj', this.proposalObj);

					this.sumAtualAdicional += this.proposalObj.LCAdicional;	
					console.log('sumAtualAdicional', this.sumAtualAdicional);
					
					this.isUserOwner = (this.proposalObj.ResponsavelID === localStorage.getItem('yara.userID')) || (this.proposalObj.UsuarioIDCriacao === localStorage.getItem('yara.userID'));
					console.log('this.isUserOwner', this.isUserOwner);

					this.getAccountClientFinancialDetails();
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	getAccountClientFinancialDetails() {
		this.accountClientDetailsService.getAccountClientFinancialDetails(this.token, this.accountClientID).subscribe(result => {
			if (result.Success) {
				if (result.Result) {
					this.financialObj = result.Result && result.Result.Limites ? result.Result.Limites : [];

					this.currentFinancialY = this.financialObj.find(f => f.EmpresasID === 'Y');
					console.log('currentFinancialY', this.currentFinancialY);					
					this.currentFinancialG = this.financialObj.find(f => f.EmpresasID === 'G');
					console.log('currentFinancialG', this.currentFinancialG);					
					this.lcAtual = (this.proposalObj.EmpresaID === 'Y' ? this.currentFinancialY.LC : this.currentFinancialG.LC);
					this.exposicaoAtual = (this.proposalObj.EmpresaID === 'Y' ? this.currentFinancialY.Exposicao : this.currentFinancialG.Exposicao);
					this.vigenciaAtual = (this.proposalObj.EmpresaID === 'Y' ? this.currentFinancialY.VigenciaFim : this.currentFinancialG.VigenciaFim);
					this.sumAtualAdicional += (this.proposalObj.EmpresaID === 'Y' ? this.currentFinancialY.LC : this.currentFinancialG.LC);
				}
			}
		}, error => {
			console.log(error);
		});
	}

	getCTCByAccountClient() {
		this.limiteAdicionalProposalService.getCtcByAccountClient(this.accountClientID).subscribe(result => {
			if (result.Success) {
				if (result.Result) {
					this.ctcList = result.Result ? result.Result : [];
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	getClientTypes() {
		this.limiteAdicionalProposalService.getClientType(this.token).subscribe(result => {
			if (result.Success) {
				this.clientTypes = result.Result.filter(item => item.Ativo);
				console.log("getClientTypes", this.proposalObj.PropostaLCStatusID);
				this.getAccountClienteType();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	getAccountClienteType() {
		console.log("getAccountClienteType", this.proposalObj.PropostaLCStatusID);

		this.limiteAdicionalProposalService.getAccountClienteType(this.token, this.accountClientID).subscribe(result => {
			console.log("getAccountClienteType", result.Success);
			if (result.Success) {

				if (result.Result) {
					this.setProposalType(result.Result.TipoClienteID ? result.Result.TipoClienteID : "");
				}
				
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	setProposalType(clienteTypeID) {
		this.proposalLayout = 0;
		for (var i = 0; i < this.clientTypes.length; i++) {
			if (this.clientTypes[i].ID === clienteTypeID) {
				this.proposalLayout = this.clientTypes[i].LayoutProposta;
			}
		}

		$("#ProposalLayout").val(this.proposalLayout);

		this.limiteAdicionalProposalService.proposalReload.next(true); // Aba anexos recebe essa mudança e recarrega
		console.log("Layout Selecionado:", this.proposalLayout);
	}

	setProposalTab(tab) {
		this.proposalLcTab = false;
		this.summaryTab = false;
		this.attachTab = false;
		this.logTab = false;

		switch (tab) {
			case 'proposal':
				this.proposalLcTab = true;
				break;
			case 'summary':
				this.summaryTab = true;
				break;
			case 'attach':
				this.attachTab = true;
				break;
			case 'log':
				this.logTab = true;
				break;
			default:

				break;
		}
	}

	updateProposta() {
		this.limiteAdicionalProposalService.updateLaProposal(this.proposalObj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show(result.Errors, { cssClass: 'Acompanhamento alterado com sucesso!', timeout: 6000 });
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {			
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	podeSalvar() {
		return (this.proposalObj.PropostaLCStatusID !== 'FC') && this.isUserOwner;
	}

	podeEnviarAoComite() {
		return (this.proposalObj.PropostaLCStatusID === 'XC') && this.isUserOwner;
	}

	podeFixarLc() {
		return (this.proposalObj.PropostaLCStatusID === 'WA');
	}

	podeEncerrar() {
		return (this.proposalObj.PropostaLCStatusID === 'XC' || this.proposalObj.PropostaLCStatusID === 'FC' || this.proposalObj.PropostaLCStatusID === 'AP') && this.isUserOwner;
	}

	podeSairSemSalvar() {
		return true;
	}

	sendToComite() {
		// this.removeAutomaticSave();
		let disposable = this.dialogService.addDialog(SendLaToCtcComponent, {
			accountClientID: this.accountClientID,
			proposalID: this.proposalObj['ID'],
			proposalCTC: this.proposalObj['CodigoSap'],
			target: 'comite'
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((ctc) => {
				if (ctc) {					
					this.enviarComite({
						PropostaLCAdicionalID: this.proposalObj['ID'],
						CodigoSap: ctc
					})
					// this.saveProposal(this.sumAtualAdicional, false, 'sendToComite');
				}
			});
	}

	requestFixar(final: boolean) {		
		var fixacao = [];
		var obj = {
			Integrante: '',
			LimiteSugerido: this.proposalObj.FixarLimiteCredito > this.proposalObj.LCAdicional ? this.proposalObj.LCAdicional : this.proposalObj.FixarLimiteCredito,
			//VigenciaSugerida: '',
			VigenciaFimSugerida: this.proposalObj.VigenciaAdicional,
			//LC: 0,
			Vigencia: this.proposalObj.VigenciaAdicional,
			//VigenciaFim: '',
			ContaClienteID: this.accountClientID,
			PropostaLCAdicionalId: this.proposalObj.ID,
			//Rating: ''
		}

		fixacao.push(obj);

		let disposable = this.dialogService.addDialog(FixedLimitLAComponent, {
			proposalID: this.proposalObj.ID,			
			approvalLC: this.proposalObj.FixarLimiteCredito > this.proposalObj.LCAdicional ? this.proposalObj.LCAdicional : this.proposalObj.FixarLimiteCredito,
			aprovalFinal: final,
			group: 0,
			approvalFinanceGroup: fixacao
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				if (isConfirmed) {
					this.flashMessagesService.show("Proposta Aprovada e Finalizada", { cssClass: 'alert-success', timeout: 6000 });
					this.reloadAccountClient();
				}
				else {
					//Do nothing here
				}
			});		
	}

	sendToEncerrar() {
		var message = "Confirma o encerramento da Proposta de LC Adicional?";
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmação',
			message: message
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.encerrar();
				}
				else {
					//Do nothing here
				}
			});
	}

	sairSemSalvar() {
		this.reloadAccountClient();
	}

	isApprover() {
		return this.proposalObj.PropostaLCStatusID === 'FC' && this.isUserOwner;
	}

	encerrar() {
		this.limiteAdicionalProposalService.sendToEncerrar(this.proposalObj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta Encerrada", { cssClass: 'alert-success', timeout: 6000 });
				this.reloadAccountClient();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			return false;
		});
	}
	
	reloadAccountClient() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID);
			});
	}

	reloadProposalLA() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID+'/proposta-la');
			});
	}

	enviarComite(obj) {
		this.limiteAdicionalProposalService.sendToComite(obj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta enviada ao Comitê de aprovação", { cssClass: 'alert-success', timeout: 6000 });
				this.reloadProposalLA();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.flashMessagesService.show(error, { cssClass: 'alert-danger', timeout: 6000 });
			return false;
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/limite-adicional-proposal/component/limite-adicional-proposal/limite-adicional-proposal.component.ts